module.exports = __webpack_public_path__ + "static/images/clothing.whzQ29s.svg";